import React from "react";
import styled from "styled-components";
import { DocumentSection } from "@domain/lms/article/article";
import { DetailedArticle } from "@domain/lms/article/dtos";
import { getAssetById } from "@domain/lms/article/utils";
import { PdfViewer } from "@ui/components/media/pdf/pdfViewer";

interface DocumentSectionViewProps extends React.HTMLAttributes<HTMLDivElement> {
	section: DocumentSection;
	article: DetailedArticle;
}
export const DocumentSectionView: React.FC<DocumentSectionViewProps> = ({ section, article, ...htmlProps }) => {
	const asset = getAssetById(article.content, section.assetId);

	if (!asset) {
		return null;
	}
	return (
		<Container {...htmlProps}>
			<PdfViewer source={asset.url} pdfHeight={600} />
		</Container>
	);
};

const Container = styled.div`
	width: 100%;
	border-radius: 12px;
	overflow: hidden;
	background-color: ${({ theme }) => theme.colors.white};
`;
